---
nb:
  add_company: Legg til bedrift
  add_parent_company: Legg til morselskap
  cancel: Avbryt
  companies:
    community_access_locked: Fellesskapsinnlegg er deaktivert av morselskap
    delete_company: Slett bedrift
    errors:
      missing_company: Selskapet må være tilgjengelig for trevisningen.
  delete: Slett
  edit: Rediger
  external_URLs: Extern URLs
  kiosk_mode_setup: Kiosk modus oppsett
  name: Navn
  ownership_share: Eierandel
  ownership_share_saves_on_exit: Lagres når du går ut av feltet
  ownership_share_unlock: Lås opp for å endre eierandelen. Den lagres straks du forlater feltet.
  parent_companies: Morselskaper
  parent_company_last_parent_locked: Kan ikke fjerne siste morselskap. For å gjøre denne bedriften til toppnivå, kontakt support.
  parent_company_locked: Låst
  portal_config: Portalkonfigurasjon
  save: Lagre
  select_parent_company: Velg morselskap
  subsidiaries: Datterselskaper
